// ** React Imports
import { useCallback, useRef, useState } from 'react';

// ** Third Party Components
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';

// ** Vertical Menu Components
import VerticalMenuHeader from './VerticalMenuHeader';
import VerticalNavMenuItems from './VerticalNavMenuItems';

function Sidebar({
  menuCollapsed,
  menu,
  skin,
  menuData,
  ...rest
}) {
  const props = {
    menuCollapsed,
    menu,
    skin,
    menuData,
    ...rest,
  };
  // ** States
  const hoverRef = useRef(null);
  const [groupOpen, setGroupOpen] = useState([]);
  const [groupActive, setGroupActive] = useState([]);
  const [currentActiveGroup, setCurrentActiveGroup] = useState([]);
  const [activeItem, setActiveItem] = useState(null);

  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false);

  // ** Ref
  const shadowRef = useRef(null);

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true);
    clearTimeout(hoverRef.current);
  };
  const onMouseLeave = () => {
    hoverRef.current = setTimeout(() => {
      setMenuHover(false);
    }, 500);
  };

  // ** Scroll Menu
  const scrollMenu = useCallback((container) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block');
      }
    } else if (shadowRef.current.classList.contains('d-block')) {
      shadowRef.current.classList.remove('d-block');
    }
  }, []);

  return (
    <div
      className={classnames('main-menu menu-fixed menu-accordion menu-shadow', {
        expanded: menuHover || menuCollapsed === false,
        'menu-light': skin !== 'semi-dark' && skin !== 'dark',
        'menu-dark': skin === 'semi-dark' || skin === 'dark',
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {menu ? (
        menu({ ...props, })
      ) : (
        <>
          {/* Vertical Menu Header */}
          <VerticalMenuHeader setGroupOpen={setGroupOpen} menuHover={menuHover} {...props} />
          {/* Vertical Menu Header Shadow */}
          <div className="shadow-bottom" ref={shadowRef} />
          {/* Perfect Scrollbar */}
          <PerfectScrollbar
            className="main-menu-content"
            options={{ wheelPropagation: true, }}
            onScrollY={container => scrollMenu(container)}
          >
            <ul className="navigation navigation-main">
              <VerticalNavMenuItems
                items={menuData}
                menuData={menuData}
                menuHover={menuHover}
                groupOpen={groupOpen}
                activeItem={activeItem}
                groupActive={groupActive}
                setGroupOpen={setGroupOpen}
                menuCollapsed={menuCollapsed}
                setActiveItem={setActiveItem}
                setGroupActive={setGroupActive}
                currentActiveGroup={currentActiveGroup}
                setCurrentActiveGroup={setCurrentActiveGroup}
              />
            </ul>
          </PerfectScrollbar>
        </>
      )}
    </div>
  );
}

Sidebar.propTypes = {
  menuCollapsed: PropTypes.any,
  menu: PropTypes.any,
  skin: PropTypes.any,
  menuData: PropTypes.any,
};
export default Sidebar;
